// const container = document.querySelector('.showcase-peek-columns');
// const cards = Array.from(container.querySelectorAll('.showcase-column'));
// const nextBtn = document.getElementById('next');
// const prevBtn = document.getElementById('prev');
// prevBtn.disabled = container.scrollLeft === 0;

// function getCurrentCardIndex() {
//     const scrollLeft = container.scrollLeft;
//     let closestIndex = 0;
//     let minDiff = Infinity;

//     cards.forEach((card, i) => {
//         const diff = Math.abs(card.offsetLeft - scrollLeft);
//         if (diff < minDiff) {
//             minDiff = diff;
//             closestIndex = i;
//         }
//     });

//     return closestIndex;
// }

// function scrollToCard(direction = 'next') {
//     let currentIndex = getCurrentCardIndex();
//     let targetIndex;

//     if (direction === 'next') {
//         targetIndex = Math.min(currentIndex + 1, cards.length - 1);
//     } else {
//         targetIndex = Math.max(currentIndex - 1, 0);
//     }

//     container.scrollTo({ left: cards[targetIndex].offsetLeft, behavior: 'smooth' });
// }

// nextBtn.addEventListener('click', () => scrollToCard('next'));
// prevBtn.addEventListener('click', () => scrollToCard('prev'));

const container = document.querySelector('.showcase-peek-columns');
const cards = Array.from(container.querySelectorAll('.showcase-column'));
const nextBtn = document.getElementById('next');
const prevBtn = document.getElementById('prev');
const gap = 30; // gap in px between cards

function updateButtons() {
    prevBtn.disabled = container.scrollLeft <= 0;
    nextBtn.disabled = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;
}

function scrollByCard(direction = 'next') {
    if (!cards.length) return;

    // width of one card including gap
    const cardStyle = getComputedStyle(cards[0]);
    const cardWidth = cards[0].offsetWidth + gap;

    let scrollAmount = direction === 'next' ? cardWidth : -cardWidth;

    container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
}

// Update buttons on scroll
container.addEventListener('scroll', updateButtons);

// Initial button state
updateButtons();

nextBtn.addEventListener('click', () => scrollByCard('next'));
prevBtn.addEventListener('click', () => scrollByCard('prev'));

container.addEventListener('scroll', () => {
    prevBtn.disabled = container.scrollLeft === 0;
    nextBtn.disabled = container.scrollLeft + container.clientWidth >= container.scrollWidth;
});